import { z } from '@plt/types'
import { ELIGIBILITY_GATES } from './constants'
import type { RefundQuoteTicket } from './types'

export { roundCurrency } from './money'

export function classifyTicketsByPaxType(
  tickets: RefundQuoteTicket[],
  paxAdtCount: number,
  paxChdCount: number,
): { adultNums: Set<string>; childNums: Set<string> } {
  return {
    adultNums: new Set(tickets.slice(0, paxAdtCount).map(t => t.number)),
    childNums: new Set(tickets.slice(paxAdtCount, paxAdtCount + paxChdCount).map(t => t.number)),
  }
}

export const RefundQuoteResultSchema = z.discriminatedUnion('eligible', [
  z.object({
    eligible: z.literal(true),
    quote: z.object({
      /** Net cash expected back from the supplier, after the consolidator fee (SPEC.md §1). */
      expectedSupplierRefund: z.number(),
      /** Penalty + non-refundable taxes + admin fee — subtracted on both ledgers. */
      airlineDeductions: z.number(),
      pltFee: z.number(),
      refundToPax: z.number(),
      currency: z.string(),
    }),
  }),

  z.object({
    eligible: z.literal(false),
    gate: z.enum(ELIGIBILITY_GATES),
    reason: z.string(),
  }),
])

export type RefundQuoteResult = z.infer<typeof RefundQuoteResultSchema>
